module.exports = __webpack_public_path__ + "media/images/kaoawase/top/img_kaoawase-909db3c8b9463b0fdfda4ff646d60a00.jpg";